import {useEffect, useState} from 'react'
import {ProgressFullScreen} from 'molecules'
import {useMemo} from 'react'
import WebStrukSetting from './WebStrukSettting'
import MobStrukSetting from './MobStrukSetting'
import {RgxMobileDevice} from 'utils/core'

export default function Index(pageProps = {}) {
  const [device, setDevice] = useState(null)
  const detectDevice = () => {
    let isMobile = RgxMobileDevice.test(navigator.userAgent)
    setDevice(isMobile ? 'mobile' : 'web')
  }
  const Content = useMemo(() => {
    const lstContent = {
      mobile: MobStrukSetting,
      web: WebStrukSetting,
    }
    if (lstContent[device]) {
      return lstContent[device]
    }
    return <></>
  }, [device])
  useEffect(() => {
    detectDevice()
    return () => {}
  }, [])
  if (!device) {
    return <ProgressFullScreen visible={true} />
  }

  return <Content />
}
